import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, Suspense as _Suspense, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-206715a3")

_pushScopeId("data-v-206715a3")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 新規登録")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" SEQ変更")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_6 = {
  key: 0,
  class: "el-icon-arrow-down"
}
const _hoisted_7 = {
  key: 1,
  class: "el-icon-arrow-right"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_button_group = _resolveComponent("el-button-group")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_cus_table = _resolveComponent("cus-table")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.isDialogMode)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            class: "add-button",
            type: "primary",
            icon: "el-icon-plus",
            size: "mini",
            plain: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDialog(_ctx.DialogGenre.Add)))
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withId(() => [
              (!_ctx.isEditSeqMode)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "edit-seq-button",
                    type: "primary",
                    icon: "el-icon-edit",
                    size: "mini",
                    plain: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEditSeqMode = true))
                  }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_button_group, {
                    key: 1,
                    class: "btn-group"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "success",
                        plain: "",
                        size: "mini",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleUpdateSeq()))
                      }, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        type: "default",
                        plain: "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleResetAllSeq())),
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_cus_table, {
      table: _ctx.table,
      tableConfig: _ctx.tableConfig,
      "default-expand-all": _ctx.defaultExpandAll,
      usePagination: false
    }, {
      prepend: _withId(() => [
        (_ctx.isDialogMode)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: "80"
            }, {
              default: _withId((scope) => [
                _createVNode("div", null, [
                  _createVNode(_component_el_button, {
                    class: "select-btn",
                    size: "mini",
                    plain: "",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.$emit('select', scope.row)),
                    icon: "el-icon-check"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { type: "expand" }, {
          header: _withId(() => [
            _createVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.defaultExpandAll = !_ctx.defaultExpandAll)),
              style: {"cursor":"pointer"}
            }, [
              (_ctx.defaultExpandAll)
                ? (_openBlock(), _createBlock("i", _hoisted_6))
                : (_openBlock(), _createBlock("i", _hoisted_7))
            ])
          ]),
          default: _withId((props) => [
            _createVNode(_component_el_form, {
              "label-position": "top",
              class: "table-expand"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "承認コメント" }, {
                  default: _withId(() => [
                    _createVNode("span", {
                      innerHTML: props.row.shoninComment.replaceAll('\n', '<br />')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "90",
          label: "SEQ"
        }, {
          default: _withId(({ row }) => [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withId(() => [
                (_ctx.isEditSeqMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode(_component_el_input, {
                        class: ["seq-input", {
                    'seq-input-error': row.hasSeqExisted,
                    'seq-input-edited': row.hasSeqEdited,
                  }],
                        modelValue: row.seq,
                        "onUpdate:modelValue": ($event: any) => (row.seq = $event),
                        modelModifiers: { number: true },
                        size: "mini",
                        maxlength: "2",
                        onChange: ($event: any) => (_ctx.handleRowSeqChanged(row))
                      }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "onChange"])
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(row.seq), 1))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      append: _withId(() => [
        (!_ctx.isDialogMode)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作",
              width: "120"
            }, {
              default: _withId((scope) => [
                _createVNode(_component_el_tooltip, {
                  content: "詳細",
                  placement: "left",
                  effect: "light"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      class: "edit-btn",
                      circle: "",
                      size: "mini",
                      onClick: ($event: any) => (_ctx.openDialog(_ctx.DialogGenre.Edit, scope.row.id)),
                      icon: "el-icon-edit",
                      plain: ""
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_tooltip, {
                  content: "削除",
                  placement: "right",
                  effect: "light"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      class: "delete-btn",
                      circle: "",
                      type: "danger",
                      size: "mini",
                      onClick: ($event: any) => (_ctx.handleDelete(scope.row)),
                      icon: "el-icon-delete",
                      plain: ""
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table", "tableConfig", "default-expand-all"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withId(() => [
        _createVNode(_component_Dialog, {
          title: _ctx.dialogTitle,
          operation: _ctx.dialogOperation,
          onSearch: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getList()))
        }, null, 8, ["title", "operation"])
      ]),
      _: 1
    }))
  ]))
})